import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/industries/retail')({
  head: () => ({
    ...buildSeoHead({ path: '/industries/retail', ...ROUTE_META['/industries/retail'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Industries', path: '/industries' }, { name: 'Retail', path: '/industries/retail' }])),
      jsonLdScript(buildWebPageSchema({ path: '/industries/retail', ...ROUTE_META['/industries/retail'] })),
    ],
  }),
});
